import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import Rodal from 'rodal';

import './style.scss';

import { fromQueryParams, capitalizeEachWord } from '../../utils';

const checkIcon = require('../../assets/icons/check-icon.png');
const linkIcon = require('../../assets/icons/link-icon.png');
const emailIcon = require('../../assets/icons/email-icon.png');
const facebookIcon = require('../../assets/icons/facebook-icon.png');
const twitterIcon = require('../../assets/icons/twitter-icon.png');
const linkedinIcon = require('../../assets/icons/linkedin-icon.png');
const questionIcon = require('../../assets/icons/question-icon.svg');
const redExclamationIcon = require('../../assets/icons/red-exclamation.svg');

const flagLinkTooltipText = `Is this a suspicious link?<br/>
Click here to flag it for our moderators to review.`;

const Candidate = (props) => {
  const {
    candidates,
    createFlaggedLink,
    createFlaggedTopic,
    fetchAllTopicsForRace,
    fetchCandidate,
    fetchRace,
    flaggedLinks,
    flaggedTopicsForRace,
    history,
    location: {
      search,
    },
    match: {
      params: {
        id: candidateId,
      },
    },
    nationalTopics,
    selectedCandidate,
    selectedRace,
    setRaceTopicMeaning,
    setSelectedCandidate,
  } = props;

  const { raceId } = fromQueryParams(search);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [flagLinkWindowOpen, setFlagLinkWindowOpen] = useState(false);
  const [linkToFlag, setLinkToFlag] = useState('');
  const [selectedExtraInfoCategory, setSelectedExtraInfoCategory] = useState();

  const [modalVisible, setModalVisible] = useState(false);
  const [flaggedModalVisible, setFlaggedModalVisible] = useState(false);
  const [currFlaggedTopic, setCurrFlaggedTopic] = useState();
  const [currFlaggedTopicReason, setCurrFlaggedTopicReason] = useState('');
  const [currFlaggedTopicMeaning, setCurrFlaggedTopicMeaning] = useState('');

  useEffect(() => {
    const onWindowResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', onWindowResize);
    return () => window.removeEventListener('resize', onWindowResize);
  }, []);

  // fetch candidate info if not available
  useEffect(() => {
    if (!selectedCandidate && candidateId) fetchCandidate(candidateId);
  }, [selectedCandidate]);

  // fetch race info if not available
  useEffect(() => {
    if (raceId && !selectedRace) fetchRace(raceId);
  }, [raceId, selectedRace]);

  useEffect(() => {
    if (candidateId) {
      setSelectedCandidate(candidateId);
      if (!candidates[candidateId]) fetchCandidate(candidateId);
    }
  }, [candidateId]);

  if (!flaggedTopicsForRace && raceId) {
    fetchAllTopicsForRace(raceId);
  }

  const submitFlaggedTopic = () => {
    createFlaggedTopic({ topic: currFlaggedTopic, reason: currFlaggedTopicReason, race: raceId });
    setModalVisible(false);
    setCurrFlaggedTopicReason('');
    setCurrFlaggedTopic();
  };

  const submitFlaggedTopicMeaning = () => {
    setRaceTopicMeaning(raceId, currFlaggedTopic, currFlaggedTopicMeaning);
    setModalVisible(false);
    setCurrFlaggedTopicMeaning('');
    setCurrFlaggedTopic();
  };

  const flaggedTopics = flaggedTopicsForRace ? flaggedTopicsForRace.map(topic => topic.topic) : [];

  const {
    votesmart_candidate: {
      bio: {
        candidate: {
          birthDate,
          congMembership: {
            experience: congressionalMembership,
          } = {},
          education: {
            institution,
          } = {},
          family,
          homeCity,
          homeState,
          photo,
          political: {
            experience: politicalExperience,
          } = {},
          profession: {
            experience: professionalExperience,
          } = {},
          religion,
        } = {},
      } = {},
      web_address: {
        webaddress: {
          address,
        } = {},
      } = {},
    } = {},
  } = selectedCandidate || {};

  const name = selectedCandidate ? selectedCandidate.name.split(' ') : '';
  const firstInitial = name ? name[0].substring(0, 1) : '';
  const lastInitial = name ? name[name.length - 1]?.substring(0, 1) : '';

  const otherCandidates = (selectedRace?.candidates || [])
    .filter(c => c._id !== selectedCandidate?._id);

  const {
    topic_stances: {
      scores = {},
      links_crawled: linksCrawled = {},
      example_sentences: exampleSentences = {},
    } = {},
  } = selectedRace || {};

  const midWidthValue = (windowWidth - 385) / 2;

  const natlScores = nationalTopics.map(({ title, description }) => ({
    title: description,
    value: scores[title] ? scores[title][candidateId] : undefined,
  })).filter(obj => !!obj.value);

  const natlTopicMap = nationalTopics.reduce((acc, { description, title }) => {
    return {
      ...acc,
      [description]: title,
    };
  }, {});

  const natlTopicNames = nationalTopics.map(t => t.title);
  const otherTopics = Object.keys(scores).filter(topic => !natlTopicNames.includes(topic));

  const otherScores = Object.entries(selectedRace?.topic_stances?.scores || {})
    .reduce((acc, [key, value]) => ({
      ...acc,
      ...(otherTopics.includes(key) && value[candidateId] !== null && value[candidateId] !== undefined ? { [key]: value[candidateId] } : {}),
    }), {});

  const candidateLinksCrawled = linksCrawled[candidateId] || [];

  const candidateExampleSentences = Object.entries(exampleSentences)
    .reduce((acc, [key, value]) => ({
      ...acc,
      ...(otherTopics.includes(key) ? { [key]: value[candidateId] } : {}),
    }), {});
  const flagLink = (link) => {
    setLinkToFlag(link);
    setFlagLinkWindowOpen(true);
  };

  const flaggedLinksBasic = flaggedLinks.map(l => l.link);

  const addresses = address?.length !== undefined ? address : [address];

  const webAddress = addresses.find(a => a?.webAddressTypeId === '3')?.webAddress;
  const email = addresses.find(a => a?.webAddressTypeId === '1')?.webAddress;
  const facebook = addresses.find(a => a?.webAddressTypeId === '5')?.webAddress;
  const twitter = addresses.find(a => a?.webAddressTypeId === '7')?.webAddress;
  const linkedin = addresses.find(a => a?.webAddressTypeId === '9')?.webAddress;

  const politicalExperiences = (politicalExperience?.length !== undefined ? politicalExperience : [politicalExperience]).filter(ex => !!ex);
  const professionalExperiences = (professionalExperience?.length !== undefined ? professionalExperience : [professionalExperience]).filter(ex => !!ex);
  const congressionalMemberships = (congressionalMembership?.length !== undefined ? congressionalMembership : [congressionalMembership]).filter(ex => !!ex);
  const education = (institution?.length !== undefined ? institution : [institution]).filter(ed => !!ed);

  const extraInfo = {
    ...politicalExperiences.length > 0 ? { 'Political Experiences': politicalExperiences.map(ex => `${ex.fullText}`) } : {},
    ...professionalExperiences.length > 0 ? { 'Professional Experiences': professionalExperiences.map(ex => `${ex.fullText}`) } : {},
    ...congressionalMemberships.length > 0 ? { 'Congressional Memberships': congressionalMemberships.map(ex => `${ex.fullText}`) } : {},
    ...education.length > 0 ? { Education: education.map(ex => `${ex.fullText}`) } : {},
    ...family ? { Family: [family] } : {},
    ...religion ? { Religion: [religion] } : {},
  };

  useEffect(() => {
    if (!selectedExtraInfoCategory && Object.keys(extraInfo).length > 0) {
      setSelectedExtraInfoCategory(Object.keys(extraInfo)[0]);
    }
  }, [extraInfo]);

  const topicMeanings = selectedRace?.topic_meanings || [];

  return (
    <div id="candidate-container">
      <div id="candidate-profile-container">
        <div id="social-container">
          {webAddress && (
          <a href={webAddress} target="_blank" rel="noreferrer">
            <div className="link-image-container">
              <img src={linkIcon} alt="Link icon" />
            </div>
          </a>
          )}
          {email && (
          <a href={`mailto:${email}`} target="_blank" rel="noreferrer">
            <div className="link-image-container">
              <img id="email-icon" src={emailIcon} alt="Email icon" />
            </div>
          </a>
          )}
          {facebook && (
          <a href={facebook} target="_blank" rel="noreferrer">
            <img className="link-image" id="facebook-icon" src={facebookIcon} alt="Facebook icon" />
          </a>
          )}
          {twitter && (
          <a href={twitter} target="_blank" rel="noreferrer">
            <img className="link-image" id="twitter-icon" src={twitterIcon} alt="Twitter icon" />
          </a>
          )}
          {linkedin && (
          <a href={linkedin} target="_blank" rel="noreferrer">
            <img className="link-image" id="linkedin-icon" src={linkedinIcon} alt="LinkedIn icon" />
          </a>
          )}
        </div>
        <div id="candidate-info-container">
          {photo ? (
            <img id="profile-photo" src={photo} alt={selectedCandidate.name} />
          ) : (
            <div id="profile-photo-empty">
              {firstInitial}{lastInitial}
            </div>
          )}
          {selectedCandidate && <h1>{selectedCandidate.name}</h1>}
          {selectedRace && <p>Running for {selectedRace.title}</p>}
          {selectedCandidate && <p>{selectedCandidate.party} {selectedCandidate.party.toUpperCase().includes('PARTY') ? '' : 'Party'}</p>}
          <div id="more-info">
            {birthDate && <p>Born {birthDate}</p>}
            {homeCity && homeState && <p>From {homeCity}, {homeState}</p>}
          </div>
        </div>
        <div id="other-candidates-container">
          <h3>Other Candidates</h3>
          <div id="other-candidates-list">
            {otherCandidates.map(c => (
              <NavLink
                key={c._id}
                to={`/candidate/${c._id}?raceId=${raceId}`}
              >
                {c.name}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
      {Object.keys(extraInfo).length > 0 && (
        <div id="candidate-extra-info-wrapper">
          <div id="section-selector-container">
            {Object.keys(extraInfo).map(title => (
              <button key={title} type="button" onClick={() => setSelectedExtraInfoCategory(title)}>
                <h2 className={selectedExtraInfoCategory === title ? 'selected' : ''}>{title}</h2>
              </button>
            ))}
          </div>
          <div id="section-content-container">
            {(extraInfo[selectedExtraInfoCategory] || []).map(val => (
              <p key={val}>{val}</p>
            ))}
          </div>
        </div>
      )}
      {natlScores.length > 0 ? (
        <div className="candidate-natl-topic-container content-container">
          <div className="top-info-container">
            <div>
              <h2>Stance on National Topics</h2>
              <p>We estimate candidate stance on these topics of national interest for every candidate in our database.</p>
            </div>
            <button
              className="compare-candidates-button"
              type="button"
              onClick={() => history.push(`/compare-candidates/${raceId}`)}
            >Compare to all candidates
            </button>
          </div>
          <div className="candidate-stance-table-container">
            <div className="favor-score-header-container">
              <p>Strongly Against</p>
              <p>Against</p>
              <p>Neutral</p>
              <p>In Favor</p>
              <p>Strongly In Favor</p>
            </div>
            <table>
              <tbody>
                {natlScores.map((score, index) => (
                  <tr>
                    <td className="topic-stance" style={index === natlScores.length - 1 ? { borderBottom: 0 } : {}}>{score.title}</td>
                    <td className="topic-value" style={index === natlScores.length - 1 ? { borderBottom: 0 } : {}}>
                      <img src={checkIcon} alt="check mark" style={{ marginLeft: `${midWidthValue + (score.value * midWidthValue)}px` }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
      {Object.keys(otherScores).length > 0 ? (
        <div className="candidate-natl-topic-container content-container">
          <div className="top-info-container">
            <div>
              <h2>Stance on Topics for {selectedRace?.title}</h2>
              <p>We run a machine learning algorithm to determine topics/issues relevant to this specific race. We’re working on making the topic names more
                intuitive, but for now you may have to infer the meaning.
              </p>
            </div>
            <button
              className="compare-candidates-button"
              type="button"
              onClick={() => history.push(`/compare-candidates/${raceId}`)}
            >Compare to all candidates
            </button>
          </div>
          <div className="candidate-stance-table-container">
            <div className="favor-score-header-container">
              <p>Strongly Against</p>
              <p>Against</p>
              <p>Neutral</p>
              <p>In Favor</p>
              <p>Strongly In Favor</p>
            </div>
            <table>
              <tbody>
                {Object.entries(otherScores).map(([key, value], index) => (
                  value !== null && value !== undefined ? (
                    <tr key={key}>
                      <td className="topic-stance" style={index === Object.keys(otherScores).length - 1 ? { borderBottom: 0 } : {}}>
                        <div>
                          <div style={{ width: '15px', height: '1px' }} />
                          {capitalizeEachWord(topicMeanings[key] || key || '')}
                          <img
                            src={questionIcon}
                            alt="question icon"
                            className="question-icon"
                            onClick={() => { setModalVisible(true); setCurrFlaggedTopic(key); }}
                          />
                          {flaggedTopics.includes(key)
                            ? <img src={redExclamationIcon} alt="question icon" className="question-icon" onClick={() => { setFlaggedModalVisible(true); setCurrFlaggedTopic(key); }} />
                            : null}
                        </div>
                      </td>
                      <td className="topic-value" style={index === Object.keys(otherScores).length - 1 ? { borderBottom: 0 } : {}}>
                        <img src={checkIcon} alt="check mark" style={{ marginLeft: `${midWidthValue + (value * midWidthValue)}px` }} />
                      </td>
                    </tr>
                  ) : null
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
      {candidateLinksCrawled.length > 0 || Object.entries(candidateExampleSentences).length > 0 ? (
        <>
          <div className="separator-line" />
          <div id="info-generate-container" className="content-container">
            <h2>Information We Used To Generate These Results</h2>
            <p>We use data on candidate speeches, publications, and confirmed social media accounts to estimate stance on the topics above.
              For candidates with limited public statements available, we scrape newspaper articles and information online to estimate their stance.
            </p>
            {candidateLinksCrawled.length > 0 && (
            <div className="info-container-parent">
              <div className="info-container">
                <h3>Links We Crawled</h3>
                <ul>
                  <ReactTooltip multiline />
                  {candidateLinksCrawled
                    .filter(l => !flaggedLinksBasic.includes(l))
                    .map(link => (
                      <li key={link.link}>
                        <div className="link-crawled-container">
                          <button
                            data-tip={flagLinkTooltipText}
                            type="button"
                            onClick={() => flagLink(link.link)}
                          > Flag Link
                          </button>
                          <div className="links-crawled">
                            <div className="title">{link.title}</div>
                            <a href={link.link} target="_blank" rel="noopener noreferrer">{link.link}</a>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            )}
            {Object.keys(candidateExampleSentences).length > 0 && (
            <div className="info-container-parent" id="example-sentences-container">
              <div className="info-container">
                <h3>Example Sentences Used In Analysis</h3>
                {Object.entries(natlTopicMap).map(([key, value]) => {
                  const sentences = exampleSentences && exampleSentences[value] ? exampleSentences[value][candidateId] : [];

                  return sentences.length > 0 ? (
                    <div key={key} className="example-sentence-category-container">
                      <h4>Topic: {key}</h4>
                      <ul>
                        {sentences.map(sentence => (
                          <li key={sentence.text + sentence.url} className="example-sentence-container">
                            {sentence.text.length > 1000 ? `${sentence.text.substring(0, 1000)}...` : sentence.text}
                            <br />
                            <a href={sentence.url} target="_blank" rel="noreferrer">
                              {sentence.url}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null;
                })}
                {Object.entries(candidateExampleSentences).map(([topic, sentences]) => (sentences.length > 0 ? (
                  <div key={topic} className="example-sentence-category-container">
                    <h4>Topic: {topic.length > 40 ? `${capitalizeEachWord(topic).substring(0, 40)}...` : capitalizeEachWord(topic)}</h4>
                    <ul>
                      {sentences.map(sentence => (
                        <li key={sentence.text + sentence.url} className="example-sentence-container">
                          {sentence.text.length > 1000 ? `${sentence.text.substring(0, 1000)}...` : sentence.text}
                          <br />
                          <a href={sentence.url} target="_blank" rel="noreferrer">
                            {sentence.url}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null))}
              </div>
            </div>
            )}
          </div>
        </>
      ) : null}
      <Rodal visible={flagLinkWindowOpen} onClose={() => setFlagLinkWindowOpen(false)} height={300} width={500}>
        <div id="flag-link-container">
          <h2>Flag A Domain</h2>
          <p>MyBallot scrapes the Internet to find articles and information on candidates.</p>
          <p>If you think this website might contain false or misleading information, flag it here. After you flag, we&apos;ll temporarily take it down until our moderators can review.</p>
          <p id="flagged-link">{linkToFlag}</p>
          <button
            type="button"
            onClick={() => createFlaggedLink(linkToFlag, () => { setLinkToFlag(''); setFlagLinkWindowOpen(false); })}
          >Flag Link
          </button>
        </div>
      </Rodal>
      <Rodal visible={modalVisible}
        onClose={() => {
          setModalVisible(false);
          setCurrFlaggedTopic();
          setCurrFlaggedTopicReason('');
          setCurrFlaggedTopicMeaning('');
        }}
        height={475}
      >
        <div className="submit-flag-topic-modal">
          <h2>Confused?</h2>
          <p>These topics were extracted by our machine learning algorithm, which might be wrong.</p>
          <p>You can either provide an interpretation of what this topic might mean, or flag this topic as irrelevant to the race.</p>
          <p>Once you submit, our moderators will review your request.</p>
          <br />
          <h4>Original topic phrase: {capitalizeEachWord(currFlaggedTopic || '')}</h4>
          <div className="flag-topic-input-container">
            <h4>Submit a better meaning</h4>
            <input
              placeholder="Interpretation of the topic"
              type="text"
              value={currFlaggedTopicMeaning}
              onChange={event => setCurrFlaggedTopicMeaning(event.target.value)}
              className="flagged-link-reason"
            />
            <button type="button" onClick={submitFlaggedTopicMeaning} className="flag-topic-button" id="submit-flagged-topic-meaning">Submit meaning</button>
          </div>
          <div className="flag-topic-input-container">
            <h4>Tell us why you are confused</h4>
            <input
              placeholder="reason..."
              type="text"
              value={currFlaggedTopicReason}
              onChange={event => setCurrFlaggedTopicReason(event.target.value)}
              className="flagged-link-reason"
            />
            <button type="button" onClick={submitFlaggedTopic} className="flag-topic-button" id="submit-flagged-topic-reason">Flag this topic for review</button>
          </div>
        </div>
      </Rodal>
      {flaggedTopicsForRace
        ? (
          <Rodal
            visible={flaggedModalVisible}
            onClose={() => {
              setFlaggedModalVisible(false);
              setCurrFlaggedTopic();
            }}
            width={450}
          >
            <div className="flagged-topic-modal">
              <h2>Flagged Topic</h2>
              <p>This topic has already been flagged as irrelevant or confusing to this race.</p>
              <p>The machine learning algorithm will re-run the data after our moderators review this topic.</p>
              <div>
                Some reasons previous users flagged this topic:
                <ul className="flagged-reason-list">
                  {flaggedTopicsForRace.filter(e => e.topic === currFlaggedTopic).slice(0, 4).map((flaggedTopic) => {
                    return (<li>{`"${flaggedTopic.reason}"`}</li>);
                  })}
                </ul>
              </div>
            </div>
          </Rodal>
        )
        : null
      }
    </div>
  );
};

export default Candidate;
